import React from "react";
import ReactSelect, {GroupBase, Props as IReactSelectProps, SelectInstance} from "react-select";
import {css, useTheme} from "@emotion/react";

import {ChevronDownIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";

import {useSelectTheme} from "../hooks/use_select_theme";

export interface ISelectProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> extends IReactSelectProps<
    Option,
    IsMulti,
    Group
> {
    ref?: React.Ref<SelectInstance<Option, IsMulti, Group>>;
    isBorderless?: boolean;
    labelContent?: string;
    dataTestId?: string;
    placeholder?: string;
    className?: string;
    instanceId?: string;
    id?: string;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string}) => {
    if (props.hasLabel) {
        return <div className={props.className}>{props.children}</div>;
    }
    return <>{props.children}</>;
};

export function Select<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: ISelectProps<Option, IsMulti, Group>
) {
    const theme = useTheme();

    const {getTheme, styles} = useSelectTheme<Option, IsMulti, Group>();
    const {labelContent, isBorderless, className, placeholder, dataTestId, ref, ...restProps} = props;

    return (
        <Wrapper hasLabel={!!labelContent} className={className} data-testid={dataTestId}>
            {labelContent ? (
                <Text mb={0.5} variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <ReactSelect
                components={{
                    DropdownIndicator: (state) => {
                        return <ChevronDownIcon css={icon} size="2" fill={theme.colors.gray[state.isDisabled ? "300" : "700"]} />;
                    }
                }}
                isSearchable={false}
                styles={{
                    ...styles,
                    ...(isBorderless && {
                        control: (provided) => ({
                            ...provided,
                            boxShadow: "none",
                            border: "none",
                            backgroundColor: "transparent"
                        })
                    })
                }}
                theme={getTheme}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
                ref={ref}
            />
        </Wrapper>
    );
}

/*
    Styles
 */
const icon = css`
    margin-right: 2rem;
`;
import React from "react";
import ReactSelect, {GroupBase, Props as IReactSelectProps, SelectInstance} from "react-select";
import {css, useTheme} from "@emotion/react";

import {ChevronDownIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";

import {useSelectTheme} from "../hooks/use_select_theme";

export interface ISelectProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> extends IReactSelectProps<
    Option,
    IsMulti,
    Group
> {
    ref?: React.Ref<SelectInstance<Option, IsMulti, Group>>;
    isBorderless?: boolean;
    labelContent?: string;
    dataTestId?: string;
    placeholder?: string;
    className?: string;
    instanceId?: string;
    id?: string;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string}) => {
    if (props.hasLabel) {
        return <div className={props.className}>{props.children}</div>;
    }
    return <>{props.children}</>;
};

export function Select<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: ISelectProps<Option, IsMulti, Group>
) {
    const theme = useTheme();

    const {getTheme, styles} = useSelectTheme<Option, IsMulti, Group>();
    const {labelContent, isBorderless, className, placeholder, dataTestId, ref, ...restProps} = props;

    return (
        <Wrapper hasLabel={!!labelContent} className={className} data-testid={dataTestId}>
            {labelContent ? (
                <Text mb={0.5} variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <ReactSelect
                components={{
                    DropdownIndicator: (state) => {
                        return <ChevronDownIcon css={icon} size="2" fill={theme.colors.gray[state.isDisabled ? "300" : "700"]} />;
                    }
                }}
                isSearchable={false}
                styles={{
                    ...styles,
                    ...(isBorderless && {
                        control: (provided) => ({
                            ...provided,
                            boxShadow: "none",
                            border: "none",
                            backgroundColor: "transparent"
                        })
                    })
                }}
                theme={getTheme}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
                ref={ref}
            />
        </Wrapper>
    );
}

/*
    Styles
 */
const icon = css`
    margin-right: 2rem;
`;
